import type { Ref } from 'vue'
import type { UseFinancingData } from '~/store-v2/financings/useFinancing'
import { computed } from 'vue'

export function useDateProps(
  stepKey: string,
  options: {
    completedAt: Ref<string | undefined>
    reprovedAt: Ref<string | undefined>
    submittedAt: Ref<string | undefined>
    blocked?: Ref<boolean>
    financing?: Ref<UseFinancingData>
  },
) {
  return computed(() => {
    const { completedAt, reprovedAt, submittedAt, blocked, financing } = options
    const canSendDates = (!blocked?.value) && financing?.value?.openable_steps?.[stepKey]

    if (!canSendDates)
      return {}

    if (completedAt.value)
      return { completedAt: completedAt.value }

    if (reprovedAt.value)
      return { reprovedAt: reprovedAt.value }

    if (submittedAt.value)
      return { submittedAt: submittedAt.value }

    return {}
  })
}
